import { gql } from "@apollo/client";import { useMutation } from "@apollo/client/react";import { useForm } from '../../../components/hooks/useForm';
import React, { useContext, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Context } from '../../../context/context';
import InputLabel from '@mui/material/InputLabel';

import toast, { Toaster } from 'react-hot-toast';
import FormControl from '@mui/material/FormControl';
import { GetDescripcionMensaje } from '../../../helpers/tools';
import config from '../../../config';
import { useNavigate } from 'react-router-dom';
import ErrorDialog from '../../../components/ErrorDialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';


import '../../../assets/css/App.css';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function CambioPassword() {
  const [context] = useContext(Context);

  const navigate = useNavigate();

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [state, setState] = useState({
    ShowCurrentPass: false,
    ShowNewPass: false,
    ShowRepeatPass: false
  });

  const handleClickShowCurrentPassword = () => {
    setState({
      ...state,
      ShowCurrentPass: !state.ShowCurrentPass
    });};

  const handleClickShowNewPassword = () => {
    setState({
      ...state,
      ShowNewPass: !state.ShowNewPass
    });};

  const handleClickShowRepeatPassword = () => {
    setState({
      ...state,
      ShowRepeatPass: !state.ShowRepeatPass
    });};

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const ValidacionPasswordExpReg = config.ValidacionPasswordExpReg;
  const ValidacionPasswordDescripcion = config.ValidacionPasswordDescripcion;
  const ReservedWord = config.ReservedWord;

  const MPassword = gql`
    mutation MPassword( $password: String!, $nuevaPassword: String!){
        changePasswordById(password: $password, nuevaPassword: $nuevaPassword) 
        {
            success,
            error,
            valorEsperado
        }
    }`;

  const [changePassword, { loading: loadingChange, error: errorChange, data: dataChange }] = useMutation(MPassword);

  useEffect(() => {
    if (!dataChange || loadingChange) return;
    if (dataChange.changePasswordById.success) {
      if (dataChange.changePasswordById.valorEsperado) {
        toast.success("Se cambio la contraseña correctamente");
        setTimeout(() => {
          navigate('/menu');
        }, 2000);
      } else {
        toast.error(dataChange.changePasswordById.error);
      }
    } else {
      let descripcionError = GetDescripcionMensaje(dataChange.changePasswordById.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataChange.changePasswordById.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else
      {
        if (dataChange.changePasswordById.error === 'ERRORDB' || parseInt(dataChange.changePasswordById.error, 10) > 0) {
          setMensajeError(dataChange.changePasswordById.error);
        }
      }
    }
  }, [dataChange]);

  useEffect(() => {
    if (!errorChange) return;
    setMensajeError("ERRORDB");
  }, [errorChange]);

  const [formValues, formHandle] = useForm({
    passwordActual: '',
    passwordUno: '',
    passwordDos: ''
  });

  const handleClick = () => {
    if (isFormValid()) {
      CambiarPassword();
    }
  };

  const isFormValid = () => {
    let validaRegExp = new RegExp(ValidacionPasswordExpReg);
    let listaPalabras = ReservedWord.split('|');

    if (formValues.passwordActual.length === 0) {
      toast.error('Debe cargar el campo Contraseña Actual.');
      return false;
    }
    if (formValues.passwordUno != formValues.passwordDos) {
      toast.error('Las contraseñas deben ser iguales.');
      return false;
    }
    if (listaPalabras.some(function (valor) {
      let reg = new RegExp(valor);
      let result = reg.test(formValues.passwordUno.toUpperCase());
      if (result) {
        toast.error('No debe contener la palabra ' + valor + ' o ' + valor.toLowerCase() + ' ni cualquier derivación.');
        return true;
      }
    })) return false;
    if (!validaRegExp.test(formValues.passwordUno)) {
      toast.error('Debe ingresar una contraseña correcta: ' + ValidacionPasswordDescripcion);
      return false;
    }
    if (formValues.passwordActual === formValues.passwordUno) {
      toast.error('La contraseña nueva debe ser distinta a la contraseña actual.');
      return false;
    } else {
      return true;
    }
  };

  const CambiarPassword = () => {
    let result = changePassword({ variables: { password: formValues.passwordActual,
        nuevaPassword: formValues.passwordUno
      } });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>  
            <div className='section-content'>
                <div style={{ marginBottom: '10px' }}>
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Contraseña actual</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-password"
              name='passwordActual'
              label='Contraseña actual'
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder='Contraseña actual'
              value={formValues.passwordActual}
              onChange={formHandle}
              type={state.ShowCurrentPass ? 'text' : 'password'}
              endAdornment={
              <InputAdornment position="end">
                                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowCurrentPassword}
                  edge="end">
                  
                                    {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                                </InputAdornment>}
              fullWidth required />
             
                    </FormControl> 
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <FormControl variant="outlined">       
                        <InputLabel htmlFor="outlined-adornment-passwordUno">Nueva Contraseña</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-passwordUno"
              name='passwordUno'
              label='Nueva Contraseña'
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder='Nueva Contraseña'
              value={formValues.passwordUno}
              onChange={formHandle}
              type={state.ShowNewPass ? 'text' : 'password'}
              endAdornment={
              <InputAdornment position="end">
                                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowNewPassword}
                  edge="end">
                  
                                    {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                                </InputAdornment>}
              fullWidth required />
                                 
                    </FormControl>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-passwordDos">Reingrese Contraseña</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-passwordDos"
              name='passwordDos'
              label='Reingrese Contraseña'
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder='Reingrese Contraseña'
              value={formValues.passwordDos}
              onChange={formHandle}
              type={state.ShowRepeatPass ? 'text' : 'password'}
              endAdornment={
              <InputAdornment position="end">
                                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowRepeatPassword}
                  edge="end">
                  
                                    {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                                </InputAdornment>}
              fullWidth required />
             
                    <br />
                    <Stack spacing={2} direction="row">
                        <CustomButton
                variant="contained"
                size="small"
                onClick={handleClick}
                endIcon={<SaveIcon />}>
                Guardar</CustomButton>
                    </Stack>   
                    </FormControl>
                </div>  
            </div>   

            <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
                                 
        </>);

};